<template>
    <div>
        <div class="header">
            <div class="text-header">
                {{ headerText }}
            </div>
            <div class="action-header">
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    :disabled="!enableButton"
                    width="180"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.inquiryForm.cancel') }}
                </v-btn>

                <v-btn
                    @click="save()"
                    width="180"
                    :disabled="!status || !enableButton"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.inquiryForm.save') }}
                </v-btn>
            </div>
        </div>

        <div class="inquiry-form-container locale-font" ref="containerStyle">
            <v-card class="content-container inquiry-profile">
                <v-container class="pa-inquiry-review" ref="profileInquiry">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.profile') }}
                    </v-row>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container">
                            <profile :img="meta.employeeImage"  />
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.name') }}
                                    </div>
                                    <div class="form-text">{{ meta.name }}</div>

                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.department') }}
                                    </div>
                                    <div class="form-text">{{ meta.department }}</div>

                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.group') }}
                                    </div>
                                    <div class="form-text">{{ meta.group }}</div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.status') }}
                                    </div>
                                    <div class="form-text">{{ meta.status }}</div>

                                    <div class="form-label">
                                        {{  $vuetify.lang.t('$vuetify.inquiryForm.startStatus') }}
                                    </div>
                                    <div class="form-text">{{ meta.statusStart }}</div>

                                    <div class="form-label">
                                        {{ $vuetify.lang.t('$vuetify.inquiryForm.endStatus') }}
                                    </div>
                                    <div class="form-text">{{ meta.statusEnd ? meta.statusEnd : '-' }}</div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="pt-1">
                        <v-col
                        class="stat"
                        v-for="quota in meta.personalLeave"
                        :key="quota.id"
                        cols="12" sm="3" md="4"
                        >
                            <div class="stat-text">
                                {{quota.leave_name}}
                            </div>
                            <v-row>
                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.quota') }}
                                </v-col>
                                <v-col cols="6" class="stat-label">{{quota.limit}}</v-col>

                                <v-col cols="6" class="stat-label">
                                    {{ $vuetify.lang.t('$vuetify.inquiryForm.used') }}
                                </v-col>
                                <v-col cols="6" class="stat-label">{{quota.use}}</v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="content-container inquiry-status">
                <v-container class="pa-inquiry-review" ref="statusInquiryCard">
                    <v-row class="ma-0 card-header" ref="statusInquiryHeader">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.inquiryStatus') }}
                    </v-row>
                    <!-- TO DO change dynamicaly depends on endDate (waiting for back fixing respond) -->
                    <v-row
                        class="mt-4 mb-4"
                        :class="statusClass(inquiryMeta.status)"
                        ref="statusInquiryType">
                        <span>{{inquiryMeta.name}}</span>
                        <div class="elipse"></div>
                        <span>{{ inquiryMeta.startDate }}</span>
                        <div class="elipse"></div>
                        <span>{{ inquiryMeta.endDate }}</span>
                    </v-row>
                    <v-row class="ma-0" ref="statusInquiryDescription">
                        <v-col
                            class="px-0 py-0"
                            cols="9">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.description') }}
                            </div>
                            <div class="form-text">{{ inquiryMeta.description}}</div>
                        </v-col>

                    </v-row>
                    <v-row class="pt-5" ref="statusInquiryApproval">
                        <div class="choices-container" ref="statusContainer">
                            <div
                                :class="choiceClass('APV')"
                                @click="changeStatus('APV')">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.approve') }}
                            </div>
                            <div
                                :class="choiceClass('REJ')"
                                @click="changeStatus('REJ')">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.reject') }}
                            </div>
                        </div>
                    </v-row>
                </v-container>
            </v-card>
            <v-card class="content-container inquiry-contact">
                <v-container class="pa-inquiry-review" ref="contactInquiry">
                    <v-row class="ma-0 card-header">
                        {{ $vuetify.lang.t('$vuetify.inquiryForm.contact') }}
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pt-0">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.emailAddress') }}
                            </div>
                            <div class="form-text">{{ meta.email }}</div>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.inquiryForm.phoneNumber') }}
                            </div>
                            <div class="form-text">{{ meta.phoneNum }}</div>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </div>
    </div>
</template>

<script>
import Profile from '@/components/Profile'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'InquiryForm',

    components: {
        Profile
    },

    computed: {
        headerText () {
            return this.$vuetify.lang.t('$vuetify.inquiryForm.inquiry')
        },

        displayItemListHeight () {
            const style = { 'overflow-y': 'auto' }
            if (this.itemListMaxHeight) {
                style['max-height'] = `${this.itemListMaxHeight}px`
            }
            return style
        }
    },

    data () {
        return {
            status: null,
            inquiryId: null,
            enableButton: true,
            itemListMaxHeight: null,
            meta: {
                // Employee Info
                employeeNo: null,
                name: '',
                email: null,
                phoneNum: null,
                department: null,
                group: null,
                status: null,
                statusStart: null,
                statusEnd: null,
                file: null,
                onsiteLocationList: [],
                employeeImage: profileDefault,
                leaveType: []
            },
            inquiryMeta: {
                // Inquiry (Request from Employee)
                name: null,
                description: null,
                startDate: null,
                endDate: null,
                status: null,
                type: null
            }
        }
    },

    methods: {
        cancel () {
            this.$router.push({ name: 'Inquiry' }, () => {})
        },

        async save () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.put(`leave-request/update/${this.inquiryId}`, {
                status: this.status
            })
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.enableButton = false
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.inquiryForm.congratulation'),
                    text: `${this.$vuetify.lang.t('$vuetify.inquiryForm.applicationStatus')} ${this.meta.name} ${this.$vuetify.lang.t('$vuetify.inquiryForm.isUpdated')}`,
                    type: 'success'
                })

                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.inquiryForm.redirecting'),
                    text: this.$vuetify.lang.t('$vuetify.inquiryForm.returnToInuiry'),
                    type: 'info'
                })

                setTimeout(() => {
                    this.cancel()
                }, 3000)
                this.$router.go(-1)
            }
        },

        async getEmployeeInformation  (id) {
            try {
                const url = `/employee/${id}`
                const res = await this.axios.get(url)

                if (res && res.data && res.data.status === 'ok') {
                    const data = res.data.data

                    this.meta = {
                        employeeNo: id,
                        name: data.name,
                        email: data.email,
                        phoneNum: data.phone_no,
                        department: data.department,
                        group: data.group,
                        status: data.status,
                        statusStart: data.status_start,
                        statusEnd: data.status_end,
                        file: null,
                        onsiteLocationList: [],
                        employeeImage: profileDefault,
                        leaveType: [],
                        date: null,
                        period: null,
                        personalLeave: data.leavetypestatic
                    }
                } else {
                    // console.error('Failed to get employee information')
                }
            } catch (error) {
                // console.error('Error fetching employee information:', error)
            }
        },

        async getInquiry (id) {
            try {
                const url = `/leave-request-detail/${id}`
                const res = await this.axios.get(url)

                if (res && res.data && res.data.status === 'ok') {
                    const data = res.data.data

                    this.meta = {
                        employeeNo: data.employeeNo
                    }

                    this.inquiryMeta = {
                        name: data.leaveName,
                        description: data.description,
                        startDate: data.requestDate,
                        endDate: data.requestEndDate,
                        status: data.status,
                        type: data.requestType
                    }
                    await this.getEmployeeInformation(this.meta.employeeNo)

                    if (this.inquiryMeta.status !== 'PND') {
                        this.status = this.inquiryMeta.status
                    }
                } else {
                    // console.error('Failed to get inquiry information')
                }
            } catch (error) {
                // console.error('Error fetching inquiry information:', error)
            }
        },

        choiceClass (statusChoice) {
            const style = 'choice'
            if (this.status === statusChoice) {
                return `${style} active`
            }

            return style
        },

        changeStatus (statusChoice) {
            this.status = statusChoice
        },

        statusClass (leaveType) {
            const base = 'ma-0 inquiry-status-label'
            if (leaveType && leaveType === 'ONS') {
                return `${base} text-yellow `
            }

            return `${base} text-red`
        },

        converToShortTime (fullFormatTime) {
            const spiltTime = fullFormatTime.split(':')
            if (spiltTime[0] > 11 && this.$vuetify.lang.current === 'en') {
                return `${('0' + (spiltTime[0] - 12)).slice(-2)}:${spiltTime[1]} ${this.$vuetify.lang.t('$vuetify.inquiryForm.pmTime')}`
            } else {
                return `${spiltTime[0]}:${spiltTime[1]} ${this.$vuetify.lang.t('$vuetify.inquiryForm.amTime')}`
            }
        }
    },

    async mounted () {
        const { id } = this.$route.params
        if (id) {
            this.inquiryId = id
            await this.getInquiry(id)
        }
    },
    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.inquiryId) {
                    await this.getInquiry(this.inquiryId)
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
}

.content-container {
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: 15px !important;
}

.inquiry-form-container {
    display: grid;
    min-height: 100%;
    height: 100%;
    margin-bottom: 2rem;
    grid-gap: 25px;
    grid-template-columns: calc(60% - 12.5px) calc(40% - 12.5px);
    color: white;

    .card-header {
        font-size: 24px;
        margin-bottom: 24px !important;
    }

    .form-label {
        font-size: 14px;
        color: #6c6c6c;
        line-height: 1.29;
        margin-bottom: 5px;

        &:not(:first-child) {
            margin-top: 23px;
        }
    }

    .form-text {
        font-size: 16px;
        line-height: 1.19;
        color: #131410;
    }

    .stat {
        & > *:not(:first-child) {
            margin-top: 10px;
        }

        .stat-text {
            padding-top: 0px;
            padding-bottom: 0px;
            font-size: 16px;
            color: #131410;
        }

        .stat-label {
            padding-top: 0px;
            padding-bottom: 0px;
            font-size: 16px;
            color: #6c6c6c;
        }
    }
}

.inquiry-profile {
    grid-column: 1 / 2;
    grid-row: 1;
}

.inquiry-status {
    grid-column: 2 / 2;
    grid-row: 1 / 3;
    height: fit-content;
}

.inquiry-contact {
    grid-column: 1 / 2;
    grid-row: 2;
}

.pa-inquiry-review {
    padding: 40px;
}

.profile-container {
    display: flex;
    justify-content: center;
}

.item-list-backgorud {
    background-color: #f9f1e6;
    font-size: 16px;
    border-radius: 10px;
}

.v-list-item__icon {
    align-self: center;
    color: #e8ac8f;
    justify-content: center;
    margin: 0px 16px 0px 0px !important;
}

.item-list-content {
    line-height: 1.44;
    font-size: 16px;
    padding: 4px;
    color: #131410 !important;
}

.item-list-action {
    color: #a8a8a8;
    margin-left: 43px !important;
}

.choices-container {
    display: inline-flex;
    padding: 0px 16px;

    .disable {
        pointer-events: none;
        cursor: not-allowed;
    }

    .choice {
        font-size: 18px;
        height: 50px;
        min-width: 180px;
        width: 50%;
    }

    .choice:first-child {
        color: #6c98ba;
        border: solid 2px #6c98ba;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;

        &:hover {
            background-color: lighten($color: #6c98ba, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #6c98ba;
        }
    }

    @media only screen and (max-width: 1850px) {
        .choice {
            min-width: 135px;
        }
    }

    @media only screen and (max-width: 1500px) {
        .choice {
            min-width: 120px;
        }
    }

    @media only screen and (max-width: 1390px) {
        .choice {
            min-width: 110px;
        }
    }

    .choice:last-child {
        color: #ff544a;
        border: solid 2px #ff544a;
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;

        &:hover {
            background-color: lighten($color: #ff544a, $amount: 30);
        }

        &.active {
            color: white;
            background-color: #ff544a;
        }
    }
}
.icon {
    width: 21px;
    height: 24px;
}
.download-container {
    display: flex;
    justify-content: center;
    background-color: #f9f1e6;
}
.attachment {
    display: flex;
    justify-content: center;
    font-weight: bold;
}
.download-text {
    font-size: 11px;
    color: #6c6c6c;
}
.hover-cursor{
    cursor: pointer;
}
.center {
    display: flex;
    justify-content: center;
}
.bold {
    font-weight: bold;
}
</style>
